module.exports = __webpack_public_path__ + "img/top-gear-B_92x92.60a44127.png";